"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=otpLoginPanelConfig.js.map